// src/pages/B2B/crm/components/CRMSubTabs.tsx
import React from 'react';
import { Link } from 'react-router-dom';

const TABS = [
  { key: 'venue-pipeline', label: 'Venue Pipeline', to: '/b2b/crm' },
  { key: 'calendar',       label: 'Calendar',       to: '/b2b/crm/calendar' },
] as const;

export function CRMSubTabs({ active }: { active: typeof TABS[number]['key'] }) {
  return (
    <div className="flex gap-1 border-b border-[#2a2a3e] mb-6">
      {TABS.map(t => {
        const isActive = t.key === active;
        return (
          <Link
            key={t.key}
            to={t.to}
            className={`px-4 py-2 text-sm font-semibold border-b-2 -mb-px no-underline ${
              isActive
                ? 'text-violet-300 border-violet-500'
                : 'text-gray-500 border-transparent hover:text-gray-300'
            }`}
          >
            {t.label}
          </Link>
        );
      })}
    </div>
  );
}
